import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Subtract } from '../../../assets/images/web-isn';
import { getPathLanguage, getQueryString } from '../../../utils/params';
import { getBannerProject } from '../detailApartment.api';
import { useParams } from 'react-router-dom';
// import * as actions from '../detailApartment.action';

function BreadcrumbApartmentComponent() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathLanguage = getPathLanguage(location);
  const searchParams = new URLSearchParams(useLocation().search);
  const [projectName, setProjectName] = useState('');
  const { id, slug } = useParams();
  const { language } = useParams();
  useEffect(() => {
    sessionStorage.removeItem('searchDataCheckInOut');
    getBannerProject(getQueryString({ language, projectId: id })).then(res => {
      if (res) {
        setProjectName(res.data.name);
      }
    });
    //eslint-disable-next-line
  }, []);

  const handleBreadOverview = () => {
    return (
      <li className="d-flex align-items-center mr-3">
        <Link
          className="child-item mr-3 text-truncate-breadcrumb-name"
          to={`${pathLanguage}/featured-projects/detail/overview/${id}/${slug}`}
        >
          {projectName}
        </Link>
        <img src={Subtract} alt="subtract" />
      </li>
    );
  };

  let textBreadcrumb = '';
  if (location.pathname.includes('/featured-projects/detail/overview/')) {
    // textBreadcrumb = t('');
    textBreadcrumb = (
      <li className="d-flex align-items-center child-active mr-3 text-truncate-breadcrumb-name">{projectName}</li>
    );
  } else if (location.pathname.includes('/featured-projects/detail/apartment-room-types/')) {
    textBreadcrumb = (
      <>
        {handleBreadOverview()}
        <li className="d-flex align-items-center child-active mr-3">{t('detailProject.apartment_title')}</li>
      </>
    );
  } else if (location.pathname.includes('/featured-projects/detail/location/')) {
    textBreadcrumb = (
      <>
        {handleBreadOverview()}
        <li className="d-flex align-items-center child-active mr-3">{t('detailProject.location_title')}</li>
      </>
    );
  } else if (location.pathname.includes('/featured-projects/detail/gallery/')) {
    textBreadcrumb = (
      <>
        {handleBreadOverview()}
        <li className="d-flex align-items-center child-active mr-3">{t('detailProject.gallery_title')}</li>
      </>
    );
  } else if (location.pathname.includes('/featured-projects/detail/facilities/')) {
    textBreadcrumb = (
      <>
        {handleBreadOverview()}
        <li className="d-flex align-items-center child-active mr-3">{t('detailProject.facilities_title')}</li>
      </>
    );
  } else if (location.pathname.includes('/featured-projects/detail/offer-sub/')) {
    textBreadcrumb = (
      <>
        {handleBreadOverview()}
        <li className="d-flex align-items-center child-active mr-3">{t('detailProject.offers_title')}</li>
      </>
    );
  }

  const handleParamBreadcrumb = () => {
    let breadcumb = ''
    switch (true) {
      case searchParams.get('home') === 'true':
        break;
      case searchParams.get('by-property') === '1':
        breadcumb = (
          <>
            <li className="d-flex align-items-center mr-3 ">
              <Link
                className="child-item mr-3 text-truncate-breadcrumb-name"
                to={`${pathLanguage}/find-property/by-property`}
              >
                {t('footer.label_by_property')}

              </Link>
              <img src={Subtract} alt="subtract" />
            </li>
          </>
        );
        break;
      case searchParams.get('by-map') === '1':
        breadcumb = (
          <>
            <li className="d-flex align-items-center mr-3 ">
              <Link
                className="child-item mr-3 text-truncate-breadcrumb-name"
                to={`${pathLanguage}/find-property/by-map`}
              >
                {t('footer.label_by_map')}
              </Link>
              <img src={Subtract} alt="subtract" />
            </li>
          </>
        );
        break;
      default:
        breadcumb = (
          <>
            <li className="d-flex align-items-center mr-3 ">
              <Link
                className="child-item mr-3 text-truncate-breadcrumb-name"
                to={`${pathLanguage}/featured-projects`}
              >
                {t('detailProject.featured_project_label')}
              </Link>
              <img src={Subtract} alt="subtract" />
            </li>
          </>
        )
        break;
    }

    return breadcumb;
  }

  return (
    <div id="breadcrumbApartmentMenu">
      <div className="container">
        <div className="apartment-breadcrumb">
          <ul className="d-flex align-items-center">
            <li className="d-flex align-items-center mr-3">
              <Link className="first-item mr-3" to={pathLanguage}>
                {t('detailProject.home_label')}
              </Link>
              <img src={Subtract} alt="subtract" />
            </li>
            {/* {searchParams.get('home') ? (
              ''
            ) : (
              <li className="d-flex align-items-center mr-3 ">
                <Link
                  className="child-item mr-3 text-truncate-breadcrumb-name"
                  to={`${pathLanguage}/featured-projects`}
                >
                  {t('detailProject.featured_project_label')}
                </Link>
                <img src={Subtract} alt="subtract" />
              </li>
            )} */}
            {handleParamBreadcrumb()}
            {/* {location.pathname.includes('/serviced-apartments/overview') ? (
              <li className="d-flex align-items-center child-active mr-3">{projectName}</li>
            ) : (
              ''
            )} */}

            {textBreadcrumb}
          </ul>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbApartmentComponent);
